<template>
  <div class="detail-topic-wrapper">
    <div class="banner">
      <img :src="topic.thumbnail || siteDefaultImg" />
    </div>
    <h3 class="title">{{ topic.title }}</h3>
    <div class="time-share">
      <div class="release_time">
        {{ topic.release_time | relativeTimeFormat('M月D日') }}
      </div>
    </div>
    <div class="description">{{ topic.description }}</div>
    <div class="body">
      <DetailWidgets :content-info="topic" :pkg="pkg"></DetailWidgets>
    </div>
  </div>
</template>

<script>
import siteDefaultImg from '@/assets/img/common/site-default.png'
import { ABS_PATH } from '@/global/config'
import DetailWidgets from '@/components/widget/DetailWidgets'

export default {
  components: {
    DetailWidgets
  },
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pkg: {
        type: 'topic',
        id: this.topic.id
      },
      ABS_PATH,
      siteDefaultImg
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  height: 408px;
  margin-bottom: 48px;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  font-size: 36px;
  font-weight: bold;
  margin: 16px 0;
  line-height: normal;
}
.time-share {
  margin-bottom: 72px;
  overflow: hidden;
}
.release_time {
  float: left;
}
.share-group {
  float: right;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.channel {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 12px;
  cursor: pointer;
  position: relative;
  i {
    width: 100%;
    height: 100%;
    display: inline-block;
    background: no-repeat center/100% 100%;
  }
  .tips {
    position: absolute;
    display: none;
    left: -118px;
    top: -148px;
    box-sizing: border-box;
    width: 264px;
    height: 134px;
    background-color: #ffffff;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.15);
    border-radius: 7px;
    padding: 12px 0 12px 12px;
    z-index: 10;

    &:after {
      position: absolute;
      content: '';
      left: 125px;
      bottom: -6px;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      background-color: #ffffff;
      border: 1px solid #ffffff;

      box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.05);

      transform: rotate(45deg);
    }

    > img {
      float: left;
      width: 110px;
      height: 110px;
    }

    > p {
      margin-top: 12px;
      margin-left: 120px;
      color: #888888;
      line-height: 28px;
      font-size: 12px;
      transform: scale(0.917);
    }
  }

  &:hover {
    .tips {
      display: block;
    }
  }
  &:last-child {
    margin-right: 0;
  }
}
.description {
  overflow: hidden;
  padding: 18px 32px 18px 24px;
  font-size: 18px;
  line-height: 28px;
  background-color: #fafafb;
  border-left: 4px solid #3352fe;
  margin-bottom: 64px;
}
</style>
